import StyledImageAvatar from './StyledImageAvatar';

interface ImageAvatarProps {
  imageSource: string;
  altText: string;
  width?: string;
  height?: string;
}

const ImageAvatar: React.FC<ImageAvatarProps> = ({
  imageSource,
  altText,
  width,
  height,
}): JSX.Element => {
  return (
    <StyledImageAvatar
      src={imageSource}
      alt={altText}
      width={width}
      height={height}
    />
  );
};

export default ImageAvatar;
